module.exports = __webpack_public_path__ + "img/2017-09_bloomberg.6a16c982.jpg";